<template>
  <div class="users-info">
    <el-card class="users-info__card" style="height: 100%">
      <div class="users-info__title">用户管理</div>
      <div class="users-info__search">
        <el-form :inline="true" :model="searchData" class="search-form">
          <el-form-item style="width: 80px">
            <el-select v-model="searchData.idType" placeholder="">
              <el-option label="rid" value="rid"></el-option>
              <el-option label="uid" value="uid"></el-option>
              <el-option label="unique_rid" value="unique_rid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchData.id" placeholder="rid"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">Search</el-button>
          </el-form-item>

          <el-form-item v-if="tableComData[0]">
            <el-button v-for="(item, index) in btnArr" :type="item.type ? item.type : 'primary'"
              @click="btnHandler(item, index, tableComData[0])" :key="index">{{ item.text }}</el-button>
            <el-button type="primary" @click="openSvipDialog(tableComData[0])">SVIP</el-button>
            <el-button :type="tableComData[0].isTester ? 'warning' : 'primary'"
              @click="changeTestHandle(tableComData[0])">
              {{ tableComData[0].isTester ? 'Cancel Test' : 'Add Test' }}
            </el-button>
            <el-button type="danger" @click="accountChangeHandle(tableComData[0])">
              {{ tableComData[0].validStatus === -1 ? 'Recover' : 'Delete' }}
            </el-button>
            <el-button type="info" @click="querySameDevice">Same Device ID</el-button>
          </el-form-item>
        </el-form>
      </div>
      <table v-loading="loading">
        <tr>
          <th>Rid</th>
          <td>{{ tableComData[0] ? tableComData[0].rid : '' }}</td>
          <th>Birth</th>
          <td>{{ tableComData[0] ? tableComData[0].birth : '' }}</td>
          <th>userLevel</th>
          <td>{{ tableComData[0] ? tableComData[0].userLevel : '' }}</td>
        </tr>
        <tr>
          <th>userLevelScore</th>
          <td>{{ tableComData[0] ? tableComData[0].userLevelScore : '' }}</td>
          <th>hostLevel</th>
          <td>{{ tableComData[0] ? tableComData[0].hostLevel : '' }}</td>
          <th>hostLevelScore</th>
          <td>{{ tableComData[0] ? tableComData[0].hostLevelScore : '' }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ tableComData[0] ? tableComData[0].name : '' }}</td>
          <th>Channel</th>
          <td>{{ tableComData[0] ? tableComData[0].channel : '' }}</td>
          <th>Coins</th>
          <td>{{ tableComData[0] ? tableComData[0].coins : '' }}</td>
        </tr>
        <tr>
          <th>Gender</th>
          <td>{{ tableComData[0] ? tableComData[0].gender : '' }}</td>
          <th>Version</th>
          <td>{{ tableComData[0] ? tableComData[0].ver : '' }}</td>
          <th>Diamonds</th>
          <td>{{ tableComData[0] ? tableComData[0].diamond : '' }}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{{ tableComData[0] ? tableComData[0].email : '' }}</td>
          <th>Valid Status</th>
          <td>{{ tableComData[0] ? tableComData[0].validStatusName : '' }}</td>
          <th>Gift Send</th>
          <td>{{ searchGold || '' }}</td>
        </tr>
        <tr>
          <th>Country</th>
          <td>{{ tableComData[0] ? tableComData[0].country : '' }}</td>
          <template v-if="tableComData[0] && tableComData[0].validStatus == 0">
            <th>Block Reason</th>
            <td>{{ tableComData[0] ? tableComData[0].blockReason : '' }}</td>
          </template>
          <template v-if="tableComData[0] && tableComData[0].validStatus != 0">
            <th></th>
            <td></td>
          </template>
          <th>VIP</th>
          <td>{{ tableComData[0] ? tableComData[0].vip : '' }}</td>
        </tr>
        <tr>
          <th>Verified Host</th>
          <td>{{ tableComData[0] ? tableComData[0].verifiedHost : '' }}</td>
          <th>Aristocracy</th>
          <td>{{ tableComData[0] ? tableComData[0].lordStatusName : '' }}</td>
          <th>signature</th>
          <td>{{ tableComData[0] ? tableComData[0].signature : '' }}</td>
        </tr>
        <tr>
          <th>Last Recharge</th>
          <td>{{ tableComData[0] ? tableComData[0].lastRechargeTime : '' }}</td>
          <th>Last Login</th>
          <td>{{ tableComData[0] ? tableComData[0].lastActiveTime : '' }}</td>
          <th>First Login</th>
          <td>{{ tableComData[0] ? tableComData[0].firstLoginTime : '' }}</td>
        </tr>
        <tr>
          <th>User Identity</th>
          <td>{{ tableComData[0] ? tableComData[0].userIdentity : '' }}</td>
          <th>Head Icon</th>
          <td>
            <img v-if="tableComData[0] && tableComData[0].headIcon" :src="tableComData[0].headIcon" 
                 style="max-width: 50px; max-height: 50px; border-radius: 50%;" 
                 @click="previewImage(tableComData[0].headIcon)" />
            <span v-else>{{ tableComData[0] ? tableComData[0].headIcon : '' }}</span>
          </td>
          <th>Self Banner Images</th>
          <td>
            <div v-if="tableComData[0] && tableComData[0].selfBannerImg && tableComData[0].selfBannerImg.length > 0">
              <div v-for="(img, index) in tableComData[0].selfBannerImg" :key="index" style="display: inline-block; margin: 2px;">
                <img :src="img" style="max-width: 40px; max-height: 40px; border-radius: 4px; cursor: pointer;" 
                     @click="previewImage(img)" />
              </div>
            </div>
            <span v-else>{{ tableComData[0] ? (tableComData[0].selfBannerImg ? tableComData[0].selfBannerImg.length + ' images' : '') : '' }}</span>
          </td>
        </tr>
        <tr>
          <th>SVIP Level</th>
          <td>{{ tableComData[0] ? tableComData[0].svipLevel : '' }}</td>
          <th>SVIP Point</th>
          <td>{{ tableComData[0] ? tableComData[0].svipPoint : '' }}</td>
          <th>Next SVIP Point</th>
          <td>{{ tableComData[0] ? tableComData[0].nextSvipPoint : '' }}</td>
        </tr>
        <tr>
          <th>SVIP Avoid Time</th>
          <td>{{ tableComData[0] ? formatTime(tableComData[0].svipAvoidTime) : '' }}</td>
          <th>City</th>
          <td>{{ tableComData[0] ? tableComData[0].city : '' }}</td>
          <th>IP</th>
          <td>{{ tableComData[0] ? tableComData[0].ip : '' }}</td>
        </tr>
        <tr>
          <th>IP First Use</th>
          <td>
            {{
              tableComData[0]
                ? tableComData[0].ipFirstUse
                  ? 'Yes'
                  : 'No'
                : ''
            }}
          </td>
          <th>Device First Use</th>
          <td>
            {{
              tableComData[0]
                ? tableComData[0].deviceFirstUse
                  ? 'Yes'
                  : 'No'
                : ''
            }}
          </td>
        </tr>
        <tr>
          <th>Special ID</th>
          <td>{{ tableComData[0] ? tableComData[0].premiumId : '' }}</td>
          <th>Special ID Expire Time</th>
          <td>{{ tableComData[0] ? formatTime(tableComData[0].premiumExpireTime) : '' }}</td>
          <th>Wearing Status </th>
          <td>{{ tableComData[0] ? (tableComData[0].premiumIdWear === 1 ? 'Yes' : 'No') : '' }}</td>
        </tr>
      </table>
    </el-card>

    <el-dialog :title="dialogProps.title" :visible.sync="dialogProps.dialogVisible" width="500px">
      <div>
        <el-form :model="updateFormData">
          <el-form-item label="rid:">
            <div>{{ updateFormData.rid }}</div>
          </el-form-item>
          <el-form-item label="name:">
            <el-input v-model="updateFormData.name" maxlength="16" show-word-limit
              v-if="dialogProps.curIndex === 0"></el-input>
            <span v-else>{{ updateFormData.name }}</span>
          </el-form-item>
          <!-- 更新用户数据 -->
          <div v-if="dialogProps.curIndex === 0">
            <el-form-item label="signature:">
              <el-input type="textarea" :rows="4" v-model="updateFormData.signature" show-word-limit
                v-if="dialogProps.curIndex === 0"></el-input>
              <span v-else>{{ updateFormData.signature }}</span>
            </el-form-item>
            <el-form-item label="Country:">
              <el-select v-model="updateFormData.country" @change="countrySelChange" filterable>
                <el-option v-for="(item, id) in countryList" :key="id" :label="item.country"
                  :value="item.country"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Gender:">
              <el-select v-model="updateFormData.gender">
                <el-option label="Male" value="Male"></el-option>
                <el-option label="Female" value="Female"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 用户封禁 -->
          <div v-if="dialogProps.curIndex === 1">
            <el-form-item label="Ban type:">
              <el-select v-model="updateFormData.blockedType">
                <el-option label="ID" :value="3"></el-option>
                <el-option label="equipment" :value="5"></el-option>
              </el-select>
            </el-form-item>
            <div>
              <el-radio-group v-model="updateFormData.blockedDurationType" :style="updateFormData.blockedDurationType === 0
                ? 'margin-bottom: 22px;'
                : ''
                ">
                <el-radio :label="0">永久</el-radio>
                <el-radio :label="1">有效时间</el-radio>
              </el-radio-group>
              <div v-if="updateFormData.blockedDurationType !== 0" style="display: inline-block">
                <el-input-number :min="0" label="描述文字" size="small" style="margin: 0 20px"
                  v-model="updateFormData.blockedDuration"></el-input-number>
                <el-form-item style="width: 100px; display: inline-block" label-width="0" inline>
                  <el-select v-model="updateFormData.durationType" placeholder="" size="small">
                    <el-option label="Days" :value="1"></el-option>
                    <el-option label="hours" :value="2"></el-option>
                    <el-option label="Minutes" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="Reason for ban:" style="word-break: keep-all">
              <el-input type="textarea" :rows="3" placeholder="reason" v-model="updateFormData.blockedReason">
              </el-input>
            </el-form-item>
            <el-form-item label="Clear Histry Performance：" style="word-break: keep-all">
              <el-checkbox v-model="updateFormData.isClearPerformance">Clear</el-checkbox>
            </el-form-item>
            <el-form-item label="Clear Histry Invite Reward" style="word-break: keep-all">
              <el-checkbox v-model="updateFormData.isClearInviteReward">Clear</el-checkbox>
            </el-form-item>
            <el-form-item label="evidence for ban：" style="word-break: keep-all">
              <UploadSingleImg v-model="updateFormData.reasonUrl" :on-upload="uploadFile" />
            </el-form-item>
          </div>
          <!-- 用户等级及等级积分修改 -->
          <div v-if="dialogProps.curIndex === 2">
            <el-form-item label="userLevel:">
              <div>{{ updateFormData.userLevel }}</div>
            </el-form-item>
            <el-form-item label="userPoints:">
              <span>{{ updateFormData.userLevelScore }}</span>
            </el-form-item>
            <el-form-item label="hostLevel:">
              <div>{{ updateFormData.hostLevel }}</div>
            </el-form-item>
            <el-form-item label="hostPoints:">
              <span>{{ updateFormData.hostLevelScore }}</span>
            </el-form-item>
            <el-form-item label="LevelType:">
              <el-select v-model="LevelType" placeholder="请选择">
                <el-option label="用户等级" :value="3"> </el-option>
                <el-option label="主播等级" :value="4"> </el-option>
              </el-select>
            </el-form-item>
            <div style="display: flex; align-items: center">
              <el-input v-model="updateFormData.updatePoints" style="margin: 0 20px; width: 200px"></el-input>
              <el-button type="primary" style="margin: 0 20px" @click="getScoreBtnHandle">Confirm</el-button>
              <span>Level: {{ updateFormData.updateLevel }}</span>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogProps.dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="updateUserInfoConfirm">Confirm</el-button>
      </span>
    </el-dialog>

    <!-- SVIP弹窗 -->
    <el-dialog title="SVIP管理" :visible.sync="svipDialogVisible" width="500px">
      <div>
        <el-form :model="svipFormData" label-width="150px">
          <el-form-item label="RID:">
            <div>{{ svipFormData.rid }}</div>
          </el-form-item>
          <el-form-item label="SVIP Level:">
            <div>{{ svipFormData.svipLevel || 0 }}</div>
          </el-form-item>
          <el-form-item label="SVIP Point:">
            <span>{{ svipFormData.svipPoint || 0 }}</span>
          </el-form-item>
          <el-form-item label="Next SVIP Point:">
            <span>{{ svipFormData.nextSvipPoint || 0 }}</span>
          </el-form-item>
          <el-form-item label="SVIP Avoid Time:">
            <span>{{ formatTime(svipFormData.svipAvoidTime) }}</span>
          </el-form-item>
          <el-form-item label="Action:">
            <el-radio-group v-model="svipFormData.svipAction">
              <el-radio :label="1">增加</el-radio>
              <el-radio :label="2">减少</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Points:">
            <el-input-number v-model="svipFormData.svipPoints" :min="0" style="width: 200px"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="svipDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="updateSvipLevel">Confirm</el-button>
      </span>
    </el-dialog>

    <!-- 同设备关联ID弹窗 -->
    <el-dialog title="Same Device ID" :visible.sync="sameDeviceDialogVisible" width="600px">
      <div v-loading="sameDeviceLoading">
        <el-tabs v-model="activeTab" type="card">
          <!-- IMEI -->
          <el-tab-pane label="IMEI" name="imei">
            <div v-if="sameDeviceData.imei || (sameDeviceData.imeiList && sameDeviceData.imeiList.length > 0)">
              <div style="margin-bottom: 10px;">
                <span v-if="sameDeviceData.imei"><strong>IMEI:</strong> {{ sameDeviceData.imei }}</span>
                <span v-if="sameDeviceData.imeiList && sameDeviceData.imeiList.length > 0" style="margin-left: 20px;">
                  <strong>Count:</strong> {{ sameDeviceData.imeiList.length }}
                </span>
              </div>
              <el-table 
                :data="sameDeviceData.imeiList || []" 
                border 
                size="small"
                max-height="300"
                style="width: 100%;">
                <el-table-column prop="rid" label="RID" width="120"></el-table-column>
                <el-table-column prop="valid" label="Status" width="100">
                  <template slot-scope="scope">
                    <el-tag size="small" :type="scope.row.valid === 'valid' ? 'success' : scope.row.valid === 'ban' ? 'warning' : 'danger'">
                      {{ scope.row.valid }}
                    </el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else style="text-align: center; padding: 20px; color: #999;">No IMEI data</div>
          </el-tab-pane>
          
          <!-- IMSI -->
          <el-tab-pane label="IMSI" name="imsi">
            <div v-if="sameDeviceData.imsi || (sameDeviceData.imsiList && sameDeviceData.imsiList.length > 0)">
              <div style="margin-bottom: 10px;">
                <span v-if="sameDeviceData.imsi"><strong>IMSI:</strong> {{ sameDeviceData.imsi }}</span>
                <span v-if="sameDeviceData.imsiList && sameDeviceData.imsiList.length > 0" style="margin-left: 20px;">
                  <strong>Count:</strong> {{ sameDeviceData.imsiList.length }}
                </span>
              </div>
              <el-table 
                :data="sameDeviceData.imsiList || []" 
                border 
                size="small"
                max-height="300"
                style="width: 100%;">
                <el-table-column prop="rid" label="RID" width="120"></el-table-column>
                <el-table-column prop="valid" label="Status" width="100">
                  <template slot-scope="scope">
                    <el-tag size="small" :type="scope.row.valid === 'valid' ? 'success' : scope.row.valid === 'ban' ? 'warning' : 'danger'">
                      {{ scope.row.valid }}
                    </el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else style="text-align: center; padding: 20px; color: #999;">No IMSI data</div>
          </el-tab-pane>
          
          <!-- TN ID -->
          <el-tab-pane label="TN ID" name="tnId">
            <div v-if="sameDeviceData.tnId || (sameDeviceData.tnIdList && sameDeviceData.tnIdList.length > 0)">
              <div style="margin-bottom: 10px;">
                <span v-if="sameDeviceData.tnId"><strong>TN ID:</strong> {{ sameDeviceData.tnId }}</span>
                <span v-if="sameDeviceData.tnIdList && sameDeviceData.tnIdList.length > 0" style="margin-left: 20px;">
                  <strong>Count:</strong> {{ sameDeviceData.tnIdList.length }}
                </span>
              </div>
              <el-table 
                :data="sameDeviceData.tnIdList || []" 
                border 
                size="small"
                max-height="300"
                style="width: 100%;">
                <el-table-column prop="rid" label="RID" width="120"></el-table-column>
                <el-table-column prop="valid" label="Status" width="100">
                  <template slot-scope="scope">
                    <el-tag size="small" :type="scope.row.valid === 'valid' ? 'success' : scope.row.valid === 'ban' ? 'warning' : 'danger'">
                      {{ scope.row.valid }}
                    </el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else style="text-align: center; padding: 20px; color: #999;">No TN ID data</div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sameDeviceDialogVisible = false">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg'
export default {
  components: {
    UploadSingleImg,
  },
  name: 'UsersInfo',
  data() {
    return {
      LevelType: 3,
      searchData: {
        idType: 'rid',
        id: '',
      },
      searchGold:0,
      tableData: [],
      loading: false,
      btnArr: [
        {
          text: 'Edit',
        },
        {
          text: 'Block',
          blockStatus: true,
        },
        {
          text: 'Level',
        },
      ],
      dialogProps: {
        title: 'edit',
        dialogVisible: false,
        // 当前点击按钮组索引
        curIndex: 0,
      },
      // 进行修改操作的表单数据
      updateFormData: {
        blockedType: 3,
        durationType: 1,
        blockedDurationType: 0,
        blockedDuration: 0,
        blockedReason: '',
        updatePoints: 0,
        updateLevel: 0,
        isClearPerformance: 0,
        isClearInviteReward: 0,
        reasonUrl: '',
        signature: '',
      },
      // SVIP弹窗
      svipDialogVisible: false,
      svipFormData: {
        rid: '',
        uid: '',
        svipLevel: 0,
        svipPoint: 0,
        nextSvipPoint: 0,
        svipAvoidTime: 0,
        svipAction: 1,
        svipPoints: 0
      },
      // 同设备关联ID弹窗
      sameDeviceDialogVisible: false,
      sameDeviceLoading: false,
      sameDeviceData: {
        imei: null,
        imeiList: [],
        imsi: null,
        imsiList: [],
        tnId: null,
        tnIdList: []
      },
      activeTab: 'imei',
      userConst: [],
      lordConst: [],
      countryList: [],
    }
  },
  mounted() {
    this.getStatusConst()
  },
  methods: {
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'actor/block/reason/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    async getGold() {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_info_admin_gold,
        withCredentials: true,
        params: {
          idType: this.searchData.idType,
          id: this.searchData.id,
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if(res.code !== 0) return this.$message({
        type: 'warning',
        message: res.msg,
      })
      this.searchGold = res.data || 0;
    },
    // 查询用户信息
    async queryUserData() {
      this.loading = true
      this.getGold();
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_info_admin,
        withCredentials: true,
        params: {
          idType: this.searchData.idType,
          id: this.searchData.id,
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      this.loading = false
      let messageType = 'success'
      let messageInfo = 'success'
      if (res.code !== 0) {
        messageType = 'warning'
        messageInfo = res.msg
        this.tableData = []
      } else {
        this.tableData = [res.data]
        const isDeBlock = res.data.validStatus === 0 ? true : false
        this.btnArr[1].blockStatus = isDeBlock
        this.btnArr[1].text = isDeBlock ? 'Un Block' : 'Block'
      }
      this.$message({
        showClose: true,
        message: messageInfo,
        type: messageType,
      })
    },
    // 获取国家列表 CountryList
    async getCountryList() {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.CountryList,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      this.countryList = res.data.countryList
    },
    // 获取用户和贵族常量
    async getStatusConst() {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.const_all,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className:
            'com.quhong.admin.constant.actormgr.ActorValidStatusConstant',
        },
      })
      this.userConst = res.data
      const { data: res1 } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.const_all,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.constant.LordConstant',
        },
      })
      this.lordConst = res1.data
    },
    // 更新用户基本信息
    async updateUserInfo() {
      let newCountry = this.countryList.find(
        (item) => item.country === this.updateFormData.country
      )
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.user_info_update,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          uid: this.updateFormData.uid,
          name: this.updateFormData.name,
          sex: this.updateFormData.gender === 'Male' ? 1 : 2,
          signature:this.updateFormData.signature,
          country: this.updateFormData.country,
          countryCode: newCountry
            ? newCountry.countryCode
            : this.updateFormData.countryCode,
          operator: this.$store.getters.username,
        },
      })
    },
    // 通过积分获取等级
    async getLevelByScore(uid, score) {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.level_by_score,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          uid: uid,
          score: score,
          levelType: this.LevelType,
        },
      })
      return res
    },
    // 获取等级处理事件
    async getScoreBtnHandle() {
      const { data: res } = await this.getLevelByScore(
        this.updateFormData.uid,
        this.updateFormData.updatePoints
      )
      this.updateFormData.updateLevel = res
    },
    // 查询
    onSubmit() {
      this.queryUserData()
    },
    countrySelChange() {
      console.log(
        this.countryList.find(
          (item) => item.country === this.updateFormData.country
        ).countryCode
      )
    },
    // 更新用户的信息确认按钮
    updateUserInfoConfirm() {
      this.$confirm('Are you sure you want to confirm the changes?', 'Tips', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          // 根据不同的操作按钮调用不同的接口 0 -> 更新基本数据 1 -> 封禁 2 -> 修改等级
          switch (this.dialogProps.curIndex) {
            case 0:
              await this.updateUserInfo()
              break
            case 1:
              await this.blockUser()
              this.updateFormData.blockedType = 3
              this.updateFormData.durationType = 1
              this.updateFormData.blockedDurationType = 0
              this.updateFormData.blockedDuration = 0
              this.updateFormData.blockedReason = ''
              this.updateFormData.reasonUrl = ''
              break
            case 2:
              await this.updateLevelScore()
              this.updateFormData.updatePoints = 0
              this.updateFormData.updateLevel = 0
            default:
              break
          }
          this.dialogProps.dialogVisible = false
          this.$message({
            type: 'success',
            message: 'change success!',
          })
          this.queryUserData()
        })
        .catch((e) => {
          console.dir(e)
          this.$message({
            type: 'info',
            message: e,
          })
        })
    },
    // 用户解封操作
    userUnblock(rowData) {
      this.$confirm('Are you sure you want to confirm the changes?', 'Tips', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { data: res } = await this.$axios({
            method: 'get',
            url: this.$store.getters.path.user_un_block,
            withCredentials: true,
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
              uid: rowData.uid,
            },
          })
          this.$message({
            type: 'success',
            message: 'change success!',
          })
          this.queryUserData()
        })
        .catch((e) => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          })
        })
    },
    // 用户封禁操作
    async blockUser() {
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.user_block,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          uid: this.updateFormData.uid,
          blockedType: this.updateFormData.blockedType,
          durationType: this.updateFormData.durationType,
          blockedDuration:
            this.blockedDurationType === 0
              ? 0
              : this.updateFormData.blockedDuration,
          blockedReason: this.updateFormData.blockedReason,
          operator: this.$store.getters.username,
          isClearPerformance: this.updateFormData.isClearPerformance ? 1 : 0,
          isClearInviteReward: this.updateFormData.isClearInviteReward ? 1 : 0,
          reasonUrl: this.updateFormData.reasonUrl,
        },
      })
    },
    // 更新等级积分
    async updateLevelScore() {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.update_level_score,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          uid: this.updateFormData.uid,
          score: this.updateFormData.updatePoints,
          levelType: this.LevelType,
        },
      })
    },
    // 打开SVIP弹窗
    openSvipDialog(rowData) {
      this.svipFormData = {
        rid: rowData.rid,
        uid: rowData.uid,
        svipLevel: rowData.svipLevel || 0,
        svipPoint: rowData.svipPoint || 0,
        nextSvipPoint: rowData.nextSvipPoint || 0,
        svipAvoidTime: rowData.svipAvoidTime || 0,
        svipAction: 1,
        svipPoints: 0
      }
      this.svipDialogVisible = true
    },
    // 更新SVIP等级
    async updateSvipLevel() {
      if (this.svipFormData.svipPoints <= 0) {
        return this.$message.warning('请输入有效的积分数')
      }
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.svip_level_update,
        withCredentials: true,
        params: {
          uid: this.svipFormData.uid,
          point: this.svipFormData.svipPoints,
          action: this.svipFormData.svipAction,
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code === 0) {
        this.$message.success('修改成功')
        this.svipDialogVisible = false
        this.svipFormData.svipPoints = 0
        this.queryUserData()
      } else {
        this.$message.error(res.msg || '修改失败')
      }
    },
    // 表格按钮点击
    btnHandler(info, index, rowData) {
      if (this.btnArr[1].blockStatus && index === 1) {
        this.userUnblock(rowData)
        return
      }
      this.dialogProps.dialogVisible = true
      this.dialogProps.title = info.text
      this.dialogProps.curIndex = index
      this.updateFormData = { ...this.updateFormData, ...rowData }
      switch (index) {
        case 0:
          this.getCountryList()
          break
        default:
          break
      }
    },
    // 设置或取消账号封禁
    changeTestHandle(row) {
      this.$confirm('Are you sure you want to confirm the changes?', 'Tips', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { data: res } = await this.$axios({
            method: 'get',
            url: this.$store.getters.path.set_test_account,
            withCredentials: true,
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
              uid: row.uid,
              isTester: !row.isTester,
            },
          })
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: 'change success!',
            })
            this.queryUserData()
          } else {
            this.$message({
              type: 'warning',
              message: res.msg,
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          })
        })
    },
    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return '-'
      // 如果是秒时间戳，需要乘以1000转换为毫秒时间戳
      const milliseconds = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
      return new Date(milliseconds).toLocaleString()
    },
    // 图片预览方法
    previewImage(imageUrl) {
      if (!imageUrl) return
      // 创建一个新窗口来预览图片
      const newWindow = window.open('', '_blank')
      newWindow.document.write(`
        <html>
          <head>
            <title>图片预览</title>
            <style>
              body { 
                margin: 0; 
                padding: 20px; 
                background: #f5f5f5; 
                display: flex; 
                justify-content: center; 
                align-items: center; 
                min-height: 100vh;
              }
              img { 
                max-width: 90%; 
                max-height: 90vh; 
                border-radius: 8px; 
                box-shadow: 0 4px 12px rgba(0,0,0,0.15);
              }
            </style>
          </head>
          <body>
            <img src="${imageUrl}" alt="预览图片" />
          </body>
        </html>
      `)
      newWindow.document.close()
    },
    // 账号删除或恢复账号
    accountChangeHandle(row) {
      if (row.validStatus === -1) {
        this.$confirm('Are you sure you want to confirm the changes?', 'Tips', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { data: res } = await this.$axios({
              method: 'get',
              url: this.$store.getters.path.recover_account,
              withCredentials: true,
              params: {
                username: this.$store.getters.username,
                token: this.$store.getters.token,
                uid: row.uid,
              },
            })
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: 'change success!',
              })
              this.queryUserData()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg,
              })
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
            })
          })
      } else {
        this.$prompt('请输入删除原因?', 'Delete', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async (reason) => {
            const { data: res } = await this.$axios({
              method: 'post',
              url: this.$store.getters.path.del_account,
              withCredentials: true,
              params: {
                username: this.$store.getters.username,
                token: this.$store.getters.token,
              },
              data: {
                uid: row.uid,
                operator: this.$store.getters.username,
                reason: reason.value,
              },
            })
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: 'change success!',
              })
              this.queryUserData()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg,
              })
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
            })
          })
      }
    },
    // 查询同设备关联ID
    async querySameDevice() {
      if (!this.tableComData[0] || !this.tableComData[0].uid) {
        this.$message.warning('Please query user information first')
        return
      }
      this.sameDeviceLoading = true
      this.sameDeviceDialogVisible = true
      this.activeTab = 'imei'
      try {
        const { data: res } = await this.$axios({
          method: 'get',
          url: this.$store.getters.path.user_info_same_device,
          withCredentials: true,
          params: {
            uid: this.tableComData[0].uid,
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
        })
        this.sameDeviceLoading = false
        if (res.code === 0) {
          this.sameDeviceData = {
            imei: res.data.imei || null,
            imeiList: res.data.imeiList || [],
            imsi: res.data.imsi || null,
            imsiList: res.data.imsiList || [],
            tnId: res.data.tnId || null,
            tnIdList: res.data.tnIdList || []
          }
          // 自动切换到有数据的第一个标签页
          if (this.sameDeviceData.imei || (this.sameDeviceData.imeiList && this.sameDeviceData.imeiList.length > 0)) {
            this.activeTab = 'imei'
          } else if (this.sameDeviceData.imsi || (this.sameDeviceData.imsiList && this.sameDeviceData.imsiList.length > 0)) {
            this.activeTab = 'imsi'
          } else if (this.sameDeviceData.tnId || (this.sameDeviceData.tnIdList && this.sameDeviceData.tnIdList.length > 0)) {
            this.activeTab = 'tnId'
          }
        } else {
          this.$message.error(res.msg || 'Query failed')
          this.sameDeviceData = {
            imei: null,
            imeiList: [],
            imsi: null,
            imsiList: [],
            tnId: null,
            tnIdList: []
          }
        }
      } catch (error) {
        this.sameDeviceLoading = false
        this.$message.error('Query failed: ' + (error.message || 'Unknown error'))
        this.sameDeviceData = {
          imei: null,
          imeiList: [],
          imsi: null,
          imsiList: [],
          tnId: null,
          tnIdList: []
        }
      }
    },
  },
  computed: {
    // 对数据进行处理
    tableComData() {
      return this.tableData.map((item) => {
        const newObj = {}
        newObj.validStatusName = this.userConst.find(
          (findItem) => findItem.value === item.validStatus
        ).enName
        if (item.lordLevel === 0) {
          newObj.lordStatusName = 'no Aristocracy'
        } else {
          newObj.lordStatusName = this.lordConst.find(
            (findItem) => findItem.value === item.lordLevel
          ).enName
        }
        newObj.verifiedHost = item.gender === 1 ? 'no' : 'yes'
        newObj.gender = item.sex === 1 ? 'Male' : 'Female'
        newObj.coins = item.gold
        newObj.vip = item.isMember
        newObj.aristocracy = item.lordLevel
        return {
          ...item,
          ...newObj,
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.users-info {
  &__card {
    margin: 0 20px;
    padding: 20px 10px;
  }

  &__title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 26px;
  }
}

.labelStyle {
  background-color: tomato;

  label {
    color: #fff;
  }
}

table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 100px;
}

th,
td {
  border: 1px solid #eceef5;
  padding: 16px 8px;
  text-align: left;
}

th {
  width: 12%;
  background-color: #f5f7fa;
}

tr:hover {
  background-color: #f5f7fa;
}
</style>
